import styled from "styled-components";
import { theme, size } from "../../../../helpers/theme"

export const Root = styled.div<{
    isLoged: boolean,
}>`
display: flex;
flex-direction: row;
align-items: center;
${(props: any) => props.isLoged && "width: 55%"};
@media (max-width: ${size.laptop}) {
width:65%; 
}
`;

export const RootMobile = styled.div`
display: flex;
flex-direction: row;
align-items: center;
@media (max-width: ${size.laptop}) {
    min-width:160px;
    margin:10px 0px;
    display:  flex;  
}
`;
export const Img = styled.img`
margin-right: 13px;
width: 36px;
height: 40px;
`;

export const Text = styled.span`
font-family: ${theme.fonts.interBold};
color:${theme.colors.black_primaryText};
margin-right: 13px;
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 20px;
line-height: 28px;
white-space: nowrap;
`;

